<template>
	<div class="mallproduct-payload">
		
		<div class="psearch">
			<van-sticky>
				<van-search 
					v-model="search.kws" 
					placeholder="请输入素材标签关键字" 
					@search="onSearch"
				/>
			</van-sticky>
		</div>

		<div class="pitem">
			<van-row>
				<van-col :span="4">
					<div class="pitem-left">
						<van-sidebar v-model="querys.tabIdx">
							<template v-for="(item,idx) in typeItem">
								<van-sidebar-item 
									:title="item.label"
									@click="handleClickType(idx)"
								/>
							</template>							
						</van-sidebar>
					</div>
				</van-col>

				<van-col :span="20">
					<div v-if="pageItem.length > 0" class="pitem-right">
						<van-list
							v-model="querys.loading"
							:finished="querys.finished"
							offset="50"
							finished-text="没有更多数据了！"
							@load="onNextPage"
						>
							<template v-for="(item,idx) in pageItem" >
								<van-cell>
									<template slot="icon"
										v-if="item.image != ''"
									>
										<van-image
											class="pimage"
											width="60"
											height="60"
											:src="item.image"
										/>
									</template>

									<template slot="title">
										{{item.title}}
									</template>
									<template slot="label">
										{{item.content}}
									</template>
									<template slot="right-icon">
										<div class="pright">

											<van-tag 
												class="send"
												type="primary"
												size="medium"
												@click="handleSend(idx)"
											> 发送 </van-tag>

										</div>
									</template>
								</van-cell>
							</template>
						</van-list>
					</div>

					<div v-else class="pitem-right">
						<div v-if="querys.loading" class="load">
							<van-loading 
								size="36px"
								type="spinner"
							/>
						</div>
						<van-empty v-else description="暂无查询商品!" />
					</div>
				</van-col>
			</van-row>
		</div>
	</div>
</template>
<script type="text/javascript">
import {wxminiCfg} from '@/config/wxmini';
import {getQwSignature} from '@/interface/qywx/qwglobal';

import {get,wxmedia} from '@/interface/oms/stock/material';
export default {
	data(){
		return {
			//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qywx',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
			querys:{
				tabIdx: '',
				loading: false,
				finished: true
			},
			typeItem:[
				{label:'全部', value: ''},
				{label:'文本', value: 1},
				// {label:'文本链接', value: 2},
				{label:'图片', value: 3},
				{label:'图文链接', value: 4},
			],
			search:{
				kws: '',
				page: 1,
				psize: 10,
				orby: '',
				sort: '',
				type: '',
				types: [],
			},
			pageItem:[]
		}
	},
	created: function() {
		this.getQywxCfg();
		this.onSearch();
	},
	methods:{
		handleSend: function(idx){
			let current = this.pageItem[idx];

			if( current.type == 1 ){
				//发送文本
				let data = {
					content: current.content
				}
				this.sendText( data );
			}else if( current.type == 3 ){
				let data = {
							mediaid: current.mediaid,
							imgUrl: current.image
						}
				this.sendImage( data );
				
				//获取图片临时凭证
				let params = {
					id: current.id,
					app: 'oms'
				}
				wxmedia( params)
					.then(res=>{
						if( res.status && ('mediaid' in res.response) ){
							//图片
							let data = {
								mediaid: res.response.mediaid,
								imgUrl: current.image
							}
							this.sendImage( data );
						}
					})
					.catch(err=>{})
			}else if( current.type == 4 ){
				//图片链接
				let data = {
					link: current.url,
					title: current.content.substring(0, 20),
					desc: current.content,
					imgUrl: current.image
				}
				this.sendNews( data );
			}
		},
		handleClickType: function(idx){
			let current = this.typeItem[idx];
			this.search.type = current.value;

			this.onSearch();
		},
		onSearch: function(){
			this.search.page = 1;
			this.pageItem = [];

			this.getPageData(this.search);
		},
		onNextPage: function(){
			this.search.page = this.search.page + 1;

			this.getPageData(this.search);
		},
		getPageData: function(search){
			this.querys.loading = true;
			get(search)
				.then(res=>{
					if( res.status && ('items' in res.response) ){

						if( res.response.items.length > 0 ){
							let _this = this;
							res.response.items.forEach( function(item){
								let row = {
									id: item.id,
									title: item.title,
									type: item.type,
									content: item.content,
									image: item.image,
									mediaid: item.mediaid,
									url: item.url,
								}

								_this.pageItem.push(row);
							})
						}

						this.querys.finished = this.pageItem.length >= res.response.total;
					}

					this.querys.loading = false;
				})
				.catch(err=>{})
		},
		//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享文本内容
		 *@param string content 文本内容 
		 */
		sendText: function(data){	
			ww.sendChatMessage({
				msgtype: 'text',
				text: {
					content: data.content
				},
				success(res){
					///alert('全消息发送成功:'+JSON.stringify(res));
				},
				fail(err){
					//alert('全消息发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ChatMessage-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享图文卡片链接
		 *@param string content 文本内容 
		 */
		sendNews: function(data){
			ww.sendChatMessage({
				msgtype: 'news',
				news: {
					link: data.link,
					title: data.title,
					desc: data.desc,
					imgUrl: data.imageUrl,
				},
				success(res){
					///alert('全消息发送成功:'+JSON.stringify(res));
				},
				fail(err){
					//alert('全消息发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ChatMessage-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享图片
		 *@param string mediaid 图片的素材 ID 
		 */
		sendImage: function(data){	
			console.log(data);
			ww.sendChatMessage({
				msgtype: 'image',
				image: {
					mediaid: data.mediaid,
					imgUrl: data.imgUrl
				},
				success(res){
					///alert('全消息发送成功:'+JSON.stringify(res));
				},
				fail(err){
					//alert('全消息发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					alert('ChatMessage-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享小程序
		 *@param map miniData 小程序参数
		 *			title: 	标题
		 *			imageUrl 图片路径，以.html结尾
		 *			page:   跳转路径
		 */
		sendMiniProgram: function(miniData){
			let pageUrl = miniData.page;
				pageUrl+= '&thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;

			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: wxminiCfg.newClient.appId,
					title: miniData.title,
					imgUrl: miniData.imgUrl,
					page: pageUrl,
				},
				success(res){
					// alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					// alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		},
	}
}
</script>